import PropTypes from 'prop-types'

const DoubleOptionPopup = ({
  isOpen,
  title,
  cancelCallback,
  confirmFirstOptionCallback,
  confirmSecondOptionCallback,
  cancelText,
  confirmTextFirst,
  confirmTextSecond,
  body,
  className,
  isLoading,
}) => {
  return (
    <div className={`modal modal--confirm ${isOpen ? 'is-active' : ''} ${className || ''}`}>
      <div className="modal-background" />
      <div className="modal-content">
        <div className="box">
          <header className="modal__header">
            <span>{title}</span>
            <button className="modal-close is-large" aria-label="close" onClick={cancelCallback} />
          </header>
          <div className="modal__inner">
            {body && <div className="modal__body">{body}</div>}
            <div className="modal__section modal__actions">
              <button className="button button-gray" onClick={cancelCallback}>
                {cancelText}
              </button>
              <button
                className={`button ${isLoading ? 'is-loading' : ''} ${
                  className?.includes('is-success') ? 'button-primary' : 'button-red'
                }`}
                onClick={() => confirmFirstOptionCallback()}
              >
                {confirmTextFirst}
              </button>

              <button
                className={`button ${isLoading ? 'is-loading' : ''} ${
                  className?.includes('is-success') ? 'button-primary' : 'button-red'
                }`}
                onClick={() => confirmSecondOptionCallback()}
              >
                {confirmTextSecond}
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

DoubleOptionPopup.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  title: PropTypes.string,
  cancelText: PropTypes.string,
  confirmTextFirst: PropTypes.string,
  confirmTextSecond: PropTypes.string,
  confirmFirstOptionCallback: PropTypes.func,
  confirmSecondOptionCallback: PropTypes.func,
  cancelCallback: PropTypes.func,
  body: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
  className: PropTypes.string,
  isLoading: PropTypes.bool,
}

DoubleOptionPopup.defaultProps = {
  className: '',
  isLoading: false,
}

export default DoubleOptionPopup
